import { startOfDay } from "date-fns";
import { GroupSiteAssociationFormValues } from "./types";

export const formatDate = (value: unknown) => {
  if (value == null || value === "") return value;

  const asString = value instanceof Date ? value.toISOString() : String(value);
  return asString.endsWith("Z") ? asString.replace(/Z$/, "+00:00") : asString;
};

export const setDateToMidnight = (date: string | Date | undefined) => {
  if (!date) return null;
  return startOfDay(typeof date === "string" ? new Date(date) : date).toISOString();
};

export const transformDatesToMidnight = (data: Partial<GroupSiteAssociationFormValues>) => ({
  ...data,
  start_date: setDateToMidnight(data.start_date),
  end_date: setDateToMidnight(data.end_date),
});
